// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Register_background_2WrPu{position:relative;width:100%;min-height:calc(var(--vh, 1vh)*100);background-color:#f2f2f2}", ""]);
// Exports
exports.locals = {
	"background": "Register_background_2WrPu"
};
module.exports = exports;
